import { Button, Stack, Typography, styled } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuthContext } from 'src/auth/useAuthContext';
import Iconify from 'src/components/iconify';
import { useThemeSettingsContext } from 'src/components/settings/ThemeSettingsContext';
import { useLocales } from 'src/locales';
import { useAIResponseStore } from 'src/sections/@dashboard/ai/Chat/AIConversation/AIMessages/useAIResponseState';
import { ConversationsList } from 'src/sections/@dashboard/ai/Chat/ConversationsList/ConversationsList';
import { useConversationsQuery } from 'src/sections/@dashboard/ai/Chat/queries/useConversationsQuery';
import { useCurrentConversation } from 'src/sections/@dashboard/ai/Chat/state/useCurrentConversation';
import { PATH_DASHBOARD } from '../../../Router/paths';
import { NavRecents } from '../NavRecents/NavRecents';
import { NavScroolbar } from '../shared/styles';

export const NavAI = () => {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const { onChangeColorPresets } = useThemeSettingsContext();
  const { conversations } = useConversationsQuery();
  const { setCurrentConversation } = useCurrentConversation();
  const { setMessages, resetAIResponse } = useAIResponseStore();
  const { translate } = useLocales();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    onChangeColorPresets('ai');
  }, [user?.settings?.themeMode]);

  const handleNewChat = () => {
    setMessages([]);
    resetAIResponse();
    setCurrentConversation(undefined);
    navigate(PATH_DASHBOARD.ai.root);
  };

  const goToSchedule = () => navigate(PATH_DASHBOARD.ai.schedules);

  return (
    <NavScroolbar>
      <NavRecents />
      <StyledContainer>
        <StyledButton variant="outlined" color="inherit" onClick={goToSchedule}>
          <Stack direction="row" alignItems="center" gap={1.5}>
            <Iconify icon="copera:ai-schedule" />
            <Typography variant="body2">
              {translate('copera_ai.nav_button.scheduled_ai_calls')}
            </Typography>
          </Stack>
          <Iconify icon="tabler:arrow-right" />
        </StyledButton>
        <StyledButton
          variant="outlined"
          color="inherit"
          onClick={handleNewChat}
        >
          <Stack direction="row" alignItems="center" gap={1.5}>
            <Iconify icon="copera:ai" />
            <Typography variant="body2">
              {translate('copera_ai.nav_button.start_a_new_chat')}
            </Typography>
          </Stack>
          <Iconify icon="tabler:edit" />
        </StyledButton>

        <Stack mt={1.5}>
          <ConversationsList
            conversations={conversations}
            shouldNavigate={true}
          />
        </Stack>
      </StyledContainer>
    </NavScroolbar>
  );
};

const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  padding: theme.spacing(1.5, 1.5, 3),
  gap: theme.spacing(1.5),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  justifyContent: 'space-between',
  padding: theme.spacing(0.75, 1.5),
  '&:hover': {
    boxShadow: 'none',
  },
}));
